import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { first, tap } from "rxjs/operators";
import { LogClass, Logger } from "src/app/logger";
import { PersonFacade } from "src/app/services/person.facade";
import { UserFacade } from "src/app/user/services/user.facade";
import { SubSink } from "subsink";
import { IPerson } from "../../interfaces";

@Component({
    selector: "circ-person-from-login",
    templateUrl: "./personFromLogin.component.html",
    styleUrls: ["./personFromLogin.component.scss"],
    standalone: false
})
@LogClass({ source: "PersonFromLoginComponent" })
export class PersonFromLoginComponent implements OnInit, OnDestroy {
  @Input() public login: string;
  @Input() public userId: string;
  public person: Observable<IPerson>;
  @Input() public showImage = true;
  @Input() public showLogin = false;
  @Input() public showName = true;
  @Input() public fontSize = 20;
  public initials: string;

  private logger: Logger;
  private subscriptions = new SubSink();

  constructor(
    private personFacade: PersonFacade,
    private userFacade: UserFacade
  ) {
    this.logger.debug("ctor");
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    if (this.login) {
      this.loadByLogin();
      return;
    }

    if (this.userId) {
      this.userFacade
        .getUser(this.userId)
        .pipe(
          tap(({ login }) => (this.login = login)),
          first()
        )
        .subscribe(() => this.loadByLogin());
      return;
    }

    this.logger.debug("empty login. Not loading.");
  }

  private loadByLogin(): void {
    this.logger.debug("loading: " + this.login);
    this.person = this.personFacade.getPersonByLogin(this.login);
    this.personFacade.loadPersonByLogin(this.login);
  }
}
